<nts-base-text-box
    #baseTextBox
    [placeholder]="placeholder"
    (inputChange)="onInput($event)">
</nts-base-text-box>
